import Vue from 'vue';
import Vuex from 'vuex';
import router from '@/router';

const LogoffUrl = 'https://accounts.ypcloud.com/logoff?redirect_uri=https://git.page';
//const LogoffUrl = 'https://accounts.ypcloud.com/logoff?redirect_uri=http://localhost:8090';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    Uid: null,
    user: null,
    returnUrl: null,
    dark:false
  },
  mutations: {
    authUser(state, userData) {
      state.Uid = userData.Uid;
      state.user = userData;
    },
    storeUser(state, user) {
      state.user = user;
    },
    clearAuthData(state) {
      state.Uid = null;
      state.user = null;
    },
    setReturnUrl(state, url){
      state.returnUrl = url;
    },
    clearReturnUrl(state){
      state.returnUrl = null;
    },
    setDarkMode(state,mode){
      state.dark=mode;
    }
  },
  actions: {
    signup({ commit, dispatch }, authData) {
      commit('authUser', {
        UToken: authData.UToken,
        Uid: authData.Uid
      });
      localStorage.setItem('Uid', authData.Uid);
      localStorage.setItem('user', JSON.stringify(authData));
      dispatch('storeUser', authData);
      //dispatch('setLogoutTimer', authData.expiresIn);
    },
    login({ commit, dispatch }, authData) {
      authData.username = authData.UserName;
      authData.password = authData.AccessToken;

      localStorage.setItem('Uid', authData.Uid);
      localStorage.setItem('user', JSON.stringify(authData));
      commit('authUser', authData);
      commit('storeUser', authData);
      //dispatch('setLogoutTimer', authData.expiresIn);
    },
    logout({ commit }) {
      commit('clearAuthData');
      localStorage.removeItem('Uid');
      localStorage.removeItem('user');
    },
    fetchUser({ commit }) {
      let user = localStorage.getItem('user');
      if (user)
        commit('authUser', JSON.parse(user));
    },
    fetchReturnUrl({commit}) {
      let url = localStorage.getItem('ReturnUrl');
      if (url)
        commit('setReturnUrl', url);
    },
    setReturnUrl({ commit }, url) {
      localStorage.setItem('ReturnUrl', url);
      commit('setReturnUrl', url);
    },
    clearReturnUrl({ commit}){
      localStorage.removeItem('ReturnUrl');
      commit('clearReturnUrl');
    },
    fetchDarkMode({commit}){
      let mode=localStorage.getItem('Darkmode');
      commit('setDarkMode',mode);
    },
    setDarkMode({commit},mode){
      localStorage.setItem('Darkmode',mode);
      commit('setDarkMode',mode);
    }

  },
  getters: {
    darkmode(state){
      return state.dark;
    },
    user(state) {
      return state.user;
    },
    returnUrl(state) {
      return state.returnUrl;
    },
    isAuthenticated(state) {
      return state.UToken !== null;
    },
    headerState: () => {
      let result = router.currentRoute.query.header ? parseInt(router.currentRoute.query.header) : 1;
      return result == 1;
    },
    footerState: () => {
      let result = router.currentRoute.query.footer ? parseInt(router.currentRoute.query.footer) : 1;
      return result == 1;
    },
    titleState: () => {
      let result = router.currentRoute.query.title ? parseInt(router.currentRoute.query.title) : 1;
      return result == 1;
    },
    scrollState: () => {
      let result = router.currentRoute.query.scroll ? parseInt(router.currentRoute.query.scroll) : 1;
      return result == 1;
    }

  }
});
